'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _limelight = require('@dotdev/limelight');

var _limelight2 = _interopRequireDefault(_limelight);

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('theme-popups', {
  onLoad: function onLoad() {
    var popupElements = this.container.querySelectorAll('[data-popup-dynamic]');
    var editingMode = JSON.parse(this.container.dataset.popupEditingMode);
    window.dynamicPopups = [];

    popupElements.forEach(function (popup, index) {
      var _popup$dataset = popup.dataset,
          popupDynamic = _popup$dataset.popupDynamic,
          popupDelay = _popup$dataset.popupDelay,
          popupExpiry = _popup$dataset.popupExpiry;

      var delay = Number(popupDelay);
      var expiry = Number(popupExpiry);

      dynamicPopups[index] = new _limelight2.default('#' + popup.id, {
        bodyClass: 'active-popup',
        hideCallback: function hideCallback(element, elements) {
          _jsCookie2.default.set(element.element.id, true, { expires: expiry });
        }
      });

      if (editingMode) {
        _jsCookie2.default.remove(popup.id);
      }

      if (_jsCookie2.default.get(popup.id) == null) {
        setTimeout(function () {
          dynamicPopups[index].show();
        }, delay);
      }
    }.bind(this));
  },
  onBlockSelect: function onBlockSelect(id) {
    _limelight2.default.elements['#PopupDynamic_' + id].show();
  },
  onBlockDeselect: function onBlockDeselect(id) {
    _limelight2.default.elements['#PopupDynamic_' + id].hide();
  }
});